import { IState } from '../../../store';

export const selectHasVerifiedDocuments = (state: IState): boolean =>
  !!state.offerData.agent?.moderationInfo?.isUserIdentifiedByDocuments;
